import { useCallback, useEffect, useMemo, useState } from 'react';

import { useDispatch, useSelector } from 'hooks';
import { fetchHolidays } from 'redux/actionCreators';

import { Interval } from 'components/types';
import { getRosterDays } from '../../roster/utils';
import { getMonthInterval } from 'utils/date';
import { RosterDay } from '../../roster/types';

type UseRosterOptions = {
  defaultInterval?: Interval;
};

type UseRosterReturn = {
  interval: Interval;
  rosterDays: RosterDay[];
  onIntervalChanged: (interval: Interval) => void;
};

export function useRosterIntervalDays(
  options?: UseRosterOptions
): UseRosterReturn {
  const dispatch = useDispatch();
  const holidays = useSelector((state) => state.holidays);
  const [interval, setInterval] = useState<Interval>(
    options?.defaultInterval ?? getMonthInterval()
  );
  const rosterDays = useMemo(
    () => getRosterDays(interval, holidays),
    [interval, holidays]
  );

  useEffect(() => {
    dispatch(fetchHolidays());
  }, [dispatch]);

  useEffect(() => {
    if (options?.defaultInterval) {
      setInterval(options.defaultInterval);
    }
  }, [options?.defaultInterval]);

  const onIntervalChanged = useCallback((newInterval: Interval) => {
    setInterval(newInterval);
  }, []);

  return { interval, rosterDays, onIntervalChanged };
}
